import { HTMLAttributes, ReactNode, MouseEventHandler, CSSProperties } from 'react'

import { IUser } from '../../../../store/reducers/users'

export interface ILoyaltyProgramProps extends HTMLAttributes<HTMLDivElement> {
  totalSum: number
  isLoading: boolean
  isShort?: boolean
  user: IUser
}

export enum DiscountLevel {
  FIRST = 'first',
  SECOND = 'second',
  THIRD = 'third',
}

export interface DiscountInfoProps {
  isKycVerified: boolean
  discountLevel: DiscountLevel
}

export interface DiscountArgs {
  isKycVerified: boolean
  checkpointIndex: number
  discountLevel: DiscountLevel
}

export interface DiscountCheckpointProps {
  style?: CSSProperties
  isChecked: boolean
  onMouseEnter?: MouseEventHandler<HTMLDivElement>
  onMouseLeave?: MouseEventHandler<HTMLDivElement>
  className?: string
  children?: ReactNode
}
